/* eslint-disable import/no-anonymous-default-export */
export default {
  path: "/product-accuracy",
  shortTitle: "Product accuracy",
  title: "Product descriptions, colour and material variation",
  category: "Products and care",
  summary: "What dimensions and photographs communicate for handmade, natural-fibre, glazed, printed and food products.",
  updated: "26 October 2026",
  sections: [
    {
      heading: "How to read a listing",
      body: [
        "Each listing states purpose, main material, size or capacity, colour, upkeep and a safety note. Treat measurements as nominal and compare them with the intended room or vessel before ordering. The bag records any selectable format and finish. Styling objects shown around a piece are scenery unless the written contents expressly include them.",
      ],
    },
    {
      heading: "Expected variation",
      body: [
        "Wheel-thrown and hand-pressed ceramics can differ slightly in profile, throwing lines, speckles and glaze pooling. Reactive glazes may shift in depth. Jute, bamboo, wool and cotton can vary in fibre tone, thickness, weave alignment and small knots. Velvet nap changes with direction and light. Paper and print runs can show minor trim or registration differences.",
        "These disclosed characteristics are not permission to supply a materially different size, material, pattern or use. Food ingredients, allergens, net weight and best-before information on the delivered package take priority for that batch.",
      ],
    },
    {
      heading: "Screens and photography",
      body: [
        "Images are original representative photography. Screen brightness, colour profile and room lighting can alter perceived tone, especially for burgundy, green glass, reactive glaze and velvet. Detail photographs are intended to show texture and should be read with the full-object view for scale.",
      ],
    },
    {
      heading: "If the item differs materially",
      body: [
        "Retain both object and packing. In even, neutral light, photograph the concern; add a ruler when scale matters. Send those images with the reference and the particular listing statement relied upon. The review separates a disclosed glaze, fibre or handmade variation from an incorrect, damaged or materially mismatched item. Statutory standards concerning description and required quality continue to apply.",
      ],
    },
  ],
};
